import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {DateConfigType} from 'types/State'
import {$PropertyType} from 'utility-types'

import {cssTheme} from '@vio/atlas/themes'
import {WEEKENDS_INDEXES} from '@vio/core/src/datePicker/config'

interface Props {
  weekdaysShort: $PropertyType<DateConfigType, 'weekdaysShort'>
  firstDayOfWeek: $PropertyType<DateConfigType, 'firstDayOfWeek'>
  shouldHighlightWeekend?: boolean
}

const WeekDaysContainer = styled.div`
  position: relative; /* ensure z-index sticks */
  padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s500};
  border-top: 1px solid ${cssTheme.colors.border.neutral.secondary};
  box-shadow: ${cssTheme.shadows.action};
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-column-gap: ${cssTheme.layout.spacing.s300};
  width: 100%;
`

const WeekDay = styled.div`
  display: table-cell;
  text-align: center;
  color: ${cssTheme.colors.content.neutral.secondary};
  ${cssTheme.typography.bodyS}
  &.--is-weekend {
    background-color: ${cssTheme.colors.background.neutral.tertiary};
    border-radius: ${cssTheme.layout.radius.sm};
  }
`

/* mimics the layout + styling of DatePickerContent to ensure the columns line up */
export const WeekDays = ({
  weekdaysShort,
  firstDayOfWeek,
  shouldHighlightWeekend
}: Props) => {
  // Shift to week start
  const weekEnd = (weekdaysShort || []).slice(0, firstDayOfWeek)
  const weekStart = (weekdaysShort || []).slice(firstDayOfWeek)
  const weekdays = [...weekStart, ...weekEnd]

  // Find indexes of weekend days for the shifted weekdays
  const weekendsIndexes = WEEKENDS_INDEXES.map(index =>
    weekdays.findIndex(weekday => weekday === weekdaysShort[index])
  )
  return (
    <WeekDaysContainer>
      {weekdays.map((day, index) => (
        <WeekDay
          key={day}
          className={cx(
            weekendsIndexes.includes(index) &&
              shouldHighlightWeekend &&
              '--is-weekend'
          )}
        >
          {day}
        </WeekDay>
      ))}
    </WeekDaysContainer>
  )
}
